<template>
    <section class="small-left">
        <div class="spacing center gray">

            <lottie :name="'chapter-1/diagram-1-ims'" :width="500" :height="604" />

        </div>
        <div class="spacing space-between">

            <div>

                <h2>What is the IMS core?</h2>
                <h3>With IMS you can offer converged mobile and fixed services over any device.</h3>

                <p>IMS is a high-performance core controller that enables LTE and 5G networks to deliver Vo5G, VoLTE, VoWiFi and multimedia services for multiple devices. IMS lets you evolve to an all-IP core.</p>

            </div>

            <infobutton>
                IMS provides a standard, future-proof network architecture with open interfaces that ensure the interoperability of multivendor equipment, while making the best use of existing network elements.
            </infobutton>

        </div>
    </section>
</template>

<script>

    import globalMixin from '@/mixins/globalMixin.js';

    export default {
        mixins: [globalMixin],
    }

</script>

<style lang="scss" scoped>

    // ...

</style>